import React from "react";
import { Container, Row, Col } from "shards-react";
import InvoicingSchedule from "../components/invoicing/InvoicingSchedule";

const InvoicingScheduleView = () => {
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <InvoicingSchedule />
        </Col>
      </Row>
    </Container>
  );
};

export default InvoicingScheduleView;
